import { FunctionCall } from "../FunctionCall";

export class ModelOutputMessageData {
  public content: string;
  public functionCalls?: FunctionCall[];
  public thinking?: string;

  constructor(data: any) {
    this.content = data.content;
    if (data.functionCalls) {
      this.functionCalls = data.functionCalls.map(
        (fc: any) => new FunctionCall(fc),
      );
    }
    this.thinking = data.thinking;
  }
}
